import Deliverables from './Deliverables'

export default Deliverables
